import { render, staticRenderFns } from "./reportslist.vue?vue&type=template&id=389f9f10"
import script from "./reportslist.vue?vue&type=script&lang=js"
export * from "./reportslist.vue?vue&type=script&lang=js"
import style0 from "./reportslist.vue?vue&type=style&index=0&id=389f9f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports